import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w-11/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();


const headers: { text: string }[] = [
    { text: 'Label' },
];

const reports = [
    {
        key: "new-member",
        title: "Number of New Members",
        route: "/reports/new-member",
        allowed: window.$hasPermission('view-new-member-reports')
    },
    {
        key: "active-member",
        title: "Number of Active Members",
        route: "/reports/active-member",
        allowed: window.$hasPermission('view-active-member-reports')
    },
    {
        key: "total-member",
        title: "Number of Total Members",
        route: "/reports/total-member",
        allowed: window.$hasPermission('view-total-members')
    },
    {
        key: "booking",
        title: "Number of New Bookings",
        route: "/reports/booking",
        allowed: window.$hasPermission('view-number-of-bookings')
    },
    {
        key: "individual-bookings",
        title: "Individual Patient Bookings",
        route: "/reports/individual-bookings",
        allowed: window.$hasPermission('view-individual-patient-bookings')
    },
    {
        key: "corporate-bookings",
        title: "Corporate Patient Bookings",
        route: "/reports/corporate-bookings",
        allowed: window.$hasPermission('view-corporate-patient-bookings')
    }
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Reports" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DataTable, {
          headers: headers,
          count: 4
        }, {
          body: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reports, (report) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: report.key
              }, [
                (report.allowed)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                      _createElementVNode("td", _hoisted_3, [
                        _createElementVNode("p", null, _toDisplayString(report.title), 1)
                      ]),
                      _createElementVNode("td", _hoisted_4, [
                        _createVNode(ActionButton, {
                          "edit-btn": "",
                          onClick: ($event: any) => (_unref(router).push(report.route))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 64))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})